var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.928,
    height: 44.826,
    viewBox: "0 0 46.928 44.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 46.928,
    height: 44.826,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M39.243,30.882h0a4.6,4.6,0,0,1-4.6-4.6V22.723H43.84v3.562A4.6,4.6,0,0,1,39.243,30.882Z",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y1: 3.39,
    transform: "translate(37.002 19.333)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y1: 3.39,
    transform: "translate(41.484 19.333)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 4.597,
    transform: "translate(34.646 25.172)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M17.157,30.882V41.959a2.289,2.289,0,0,0,2.288,2.289h17.51a2.288,2.288,0,0,0,2.288-2.289V30.882",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M41.253,6.289l-3.9,3.9h3.9l-3.591,3.591",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.047,
    cy: 7.047,
    r: 7.047,
    transform: "translate(32.256 2.988)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 10.402,
    cy: 10.207,
    rx: 10.402,
    ry: 10.207,
    transform: "translate(6.746 7.794)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y1: 5.131,
    transform: "translate(17.148 0.578)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 4.879,
    y1: 1.586,
    transform: "translate(0.579 12.616)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 3.016,
    y2: 4.151,
    transform: "translate(6.907 27.945)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 3.016,
    y2: 4.151,
    transform: "translate(24.373 27.945)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x1: 1.761,
    y1: 2.424,
    transform: "translate(8.162 5.632)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x1: 2.849,
    y2: 0.926,
    transform: "translate(2.609 21.799)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 2.424,
    x2: 1.761,
    transform: "translate(24.373 5.632)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.11c8095efa34ec5d2d50c1ef74c2fe8b.svg";
export { ForwardRef as ReactComponent };